<script>
    import router from "page";
    import Message from "../components/Message.svelte";

    import { onMount } from "svelte";

    import { getLocaleResource } from "../utils/locales.js";

    import {
        isLoading,
        isAuthenticated,
        messageObject,
        locale,
    } from "../stores.js";

    let email = null;
    let password = null;

    let emailInput, passwordInput;

    onMount(() => emailInput.focus());

    function handleEmailEnter(e) {
        if (e.key == "Enter") {
            passwordInput.focus();
        }
    }
    function handlePasswordEnter(e) {
        if (e.key == "Enter") {
            login();
        }
    }

    async function login() {
        $isLoading = true;

        try {
            if (email && password) {
                let data = await (
                    await fetch("/auth/login", {
                        method: "POST",
                        // withCredentials: true,
                        // credentials: "include",
                        headers: {
                            // Authorization: localStorage.getItem("token"),
                            Accept: "application/json",
                            "Content-type": "application/json",
                        },
                        body: JSON.stringify({ email, password }),
                    })
                ).json();

                let tokenRaw = data.token;

                if (tokenRaw) {
                    localStorage.setItem("token", tokenRaw);

                    $isAuthenticated = true;

                    router(`/`);
                } else {
                    $messageObject = {
                        showMessage: true,
                        type: data.type,
                        message: data.message,
                    };
                }
            } else {
                $messageObject = {
                    showMessage: true,
                    type: "info",
                    message: "Внесете корисничко име и лозинка.",
                };
            }
        } catch (err) {}

        $isLoading = false;
    }
</script>

<div class="container">
    <a href="/">
        <img class="logo" src="/logo.png" />
    </a>

    <div class="title">B2B</div>

    <div class="form">
        <input
            bind:value={email}
            on:keydown={handleEmailEnter}
            bind:this={emailInput}
            placeholder={getLocaleResource($locale, "user")}
            name="email"
            autocomplete="off"
        />
        <br />

        <input
            type="password"
            bind:value={password}
            on:keydown={handlePasswordEnter}
            bind:this={passwordInput}
            placeholder={getLocaleResource($locale, "password")}
            name="password"
            autocomplete="off"
        />

        <br />
        <button class="btn btn-black" on:click={login}>
            {getLocaleResource($locale, "login")}
        </button>
    </div>

    <Message style="width: 400px; border-radius: 5px;" />
</div>

<style>
    .container {
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .title {
        font-size: 30px;
        opacity: 0.3;
        padding: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
        padding: 10px;
    }

    .form input {
        height: 40px;
        width: 250px;
    }

    .logo {
        width: 150px;
    }
</style>
